import { lazy, Suspense, useEffect, useState } from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import { Toaster } from "~/components/ui/sonner"
import LandingLayout from "~/routes/_landing/route"
import HomePage from "~/routes/_landing._index"

const ContactPage = lazy(() => import("~/routes/_landing.contact"))

function GoogleAnalyticsDeferred() {
  const [ready, setReady] = useState(false)
  const measurementId = import.meta.env.VITE_GOOGLE_MEASUREMENT_ID

  useEffect(() => {
    const win = typeof globalThis === "undefined" ? null : globalThis.window
    if (!win) return
    let cancelled = false
    const run = () => {
      if (!cancelled) setReady(true)
    }
    if ("requestIdleCallback" in win && typeof win.requestIdleCallback === "function") {
      const id = win.requestIdleCallback(run, { timeout: 2500 })
      return () => {
        cancelled = true
        win.cancelIdleCallback(id)
      }
    }
    const t = win.setTimeout(run, 1500)
    return () => {
      cancelled = true
      win.clearTimeout(t)
    }
  }, [])

  if (!measurementId || !ready) {
    return null
  }

  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
      />
      <script
        async
        id="gtag-init"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${measurementId}', { page_path: window.location.pathname });
          `,
        }}
      />
      <noscript>
        <iframe
          title="Google Analytics"
          src={`https://www.googletagmanager.com/ns.html?id=${measurementId}`}
          height="0"
          width="0"
          className="invisible hidden"
        />
      </noscript>
    </>
  )
}

export default function App() {
  return (
    <>
      <GoogleAnalyticsDeferred />
      <Routes>
        <Route element={<LandingLayout />}>
          <Route index element={<HomePage />} />
          <Route
            path="contact"
            element={
              <Suspense fallback={<div className="min-h-svh" />}>
                <ContactPage />
              </Suspense>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <Toaster theme="light" />
    </>
  )
}
